var r = { exports: {} };
export {
  r as __module
};
